export default __webpack_public_path__ + "static/media/blogs.82189408.png";